// utils/config.js

let apiBaseUrl;

if (window.location.hostname === 'localhost') {
  // React dev server on local machine
  apiBaseUrl = 'http://192.168.1.102:8080/api'; // backend on Ubuntu
} else if (window.location.hostname === '192.168.1.102') {
  // Accessing React app directly on the server (e.g., IP in browser)
  apiBaseUrl = 'http://192.168.1.102:8080/api';
} else {
  // Production: frontend and backend are hosted together
  apiBaseUrl = '/api';
}

export default apiBaseUrl;
